(() => {
  const navs = document.querySelectorAll('[data-pino-mega]');
  if (!navs.length) return;

  const closeItem = (item, restoreFocus = false) => {
    const trigger = item?.querySelector(':scope > [data-pino-mega-trigger]');
    item?.classList.remove('is-open', 'is-hover-open');
    trigger?.setAttribute('aria-expanded', 'false');
    if (restoreFocus) trigger?.focus();
  };

  navs.forEach((nav) => {
    const items = Array.from(nav.querySelectorAll(':scope > .pino-mega__item'));
    const closeOthers = (exception) => items.forEach((item) => item !== exception && closeItem(item));

    items.forEach((item) => {
      const trigger = item.querySelector(':scope > [data-pino-mega-trigger]');
      const panel = item.querySelector(':scope > .pino-mega__panel');
      if (!trigger || !panel) return;
      let hoverCloseTimer;

      const keepHoverOpen = () => {
        window.clearTimeout(hoverCloseTimer);
        closeOthers(item);
        item.classList.add('is-hover-open');
        trigger.setAttribute('aria-expanded', 'true');
      };

      const scheduleHoverClose = () => {
        window.clearTimeout(hoverCloseTimer);
        hoverCloseTimer = window.setTimeout(() => {
          if (item.matches(':hover') || panel.matches(':hover')) return;
          item.classList.remove('is-hover-open');
          if (!item.classList.contains('is-open') && !item.contains(document.activeElement)) {
            trigger.setAttribute('aria-expanded', 'false');
          }
        }, 160);
      };

      trigger.addEventListener('focus', () => {
        closeOthers(item);
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      });

      trigger.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          closeOthers(item);
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          panel.querySelector('a[href]')?.focus();
        } else if (event.key === 'Escape') {
          event.preventDefault();
          closeItem(item, true);
        }
      });

      panel.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeItem(item, true);
        }
      });

      item.addEventListener('mouseenter', keepHoverOpen);
      panel.addEventListener('mouseenter', keepHoverOpen);
      item.addEventListener('mouseleave', scheduleHoverClose);
      panel.addEventListener('mouseleave', scheduleHoverClose);
      item.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          if (!item.contains(document.activeElement)) closeItem(item);
        });
      });
    });

    document.addEventListener('pointerdown', (event) => {
      if (!nav.contains(event.target)) items.forEach((item) => closeItem(item));
    });
  });
})();
